module.exports = __webpack_public_path__ + "assets/line_dashed.4dc09997.svg";